ActionTypes = require 'constants/ActionTypes'
Dispatcher = require '../dispatcher/Dispatcher'


AgentsDashboardActionCreator =
  subscribe: ->
    Dispatcher.dispatch
      type: ActionTypes.MQTT_SUBSCRIBE
      payload:
        topic: "smstool/dashboard_users"
        actionType: ActionTypes.MQTT_DASHBOARD_USERS_UPDATING
        initial: true

  unSubscribe: ->
    Dispatcher.dispatch
      type: ActionTypes.MQTT_UNSUBSCRIBE
      payload:
        topic: "smstool/dashboard_users"
        actionType: ActionTypes.MQTT_DASHBOARD_USERS_UPDATING

module.exports = AgentsDashboardActionCreator
